import { Avatar as RawAvatar, styled } from '@arpeggi/ui'

const Root = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '16px'
})

const Title = styled('div', {
  fontSize: '$12',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  marginRight: '12px'
})

const Avatar = styled(RawAvatar, {
  width: '24px !important',
  minWidth: '24px',
  marginRight: '12px'
})

const Link = styled('span', {
  color: '$indigo0600',
  fontWeight: 500,
  marginRight: '4px',
  whiteSpace: 'nowrap'
})

const Stats = styled('div', {
  fontSize: '$12',
  color: '$blackA600',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  display: 'flex',
  justifyContent: 'end',
  flexGrow: 1
})

export const Notification = { Root, Title, Avatar, Stats, Link }
